import { HTTP_OK, HTTP_CREATED } from './constants';

export const isHttpOk = (status) => [HTTP_OK, HTTP_CREATED].includes(status);
